// extracted by mini-css-extract-plugin
module.exports = {"VerifyEmailPurchase":"VerifyEmailPurchase_VerifyEmailPurchase__3QeQN","Link":"VerifyEmailPurchase_Link__3xd4_"};